import { signal } from "@preact/signals-react"
import { getSubmit, postSubmit } from "@ui-seeker/utils"

import { BACKEND_APIS } from "@constants"

// News state lives here, not in the components: every module route mounts its own AppLayout, so a
// popup that fetched on mount would show the "always" announcements again — and the skipped "once"
// ones — on each change of module, not once per app load as the editor promises.

export const pendingNews = signal([])
export const pendingNewsIndex = signal(0)
let pendingLoadedFor = null
let markedIds = new Set()

// Bumped each time an announcement is marked as read, from wherever it happens: the popup and the
// News button are mounted apart, and the badge belongs to the button. A counter and not the unread
// number: the count is the server's to say, this only says "ask again".
export const newsSeenTick = signal(0)

// Once per signed-in person and app load. Failures are swallowed: an announcement is the least
// important thing on screen and a 500 here must never stand between the user and the app.
export function loadPendingNews(username) {
	if (!username || pendingLoadedFor === username) return
	pendingLoadedFor = username
	markedIds = new Set()
	pendingNewsIndex.value = 0
	pendingNews.value = []
	getSubmit(`${BACKEND_APIS.ANNOUNCEMENTS}/pending`)
		.then(res => { pendingNews.value = res?.data ?? [] })
		.catch(() => { pendingNews.value = [] })
}

// Sent at most once per id and never awaited: closing the popup must feel instant
export function markNewsSeen(idAnnouncement) {
	if (!idAnnouncement || markedIds.has(idAnnouncement)) return Promise.resolve()
	markedIds.add(idAnnouncement)
	return postSubmit(`${BACKEND_APIS.ANNOUNCEMENTS}/${idAnnouncement}/seen`, {})
		.then(() => { newsSeenTick.value = newsSeenTick.value + 1 })
		.catch(() => {})
}
